import { GetScenarios } from "../services/dataService";
const requestScenariosType = "REQUEST_SCENARIOS";
const receiveScenariosType = "RECEIVE_SCENARIOS";
const SCENARIO_MODAL_LOAD_TYPE = "SCENARIO_MODAL_LOAD";
const initialState = {
  scenarios: [],
  loading: false
};

export const actionCreators = {
  requestScenarios: () => async (dispatch, getState) => {
    dispatch({ type: requestScenariosType });

    const scenarios = await GetScenarios();

    dispatch({ type: receiveScenariosType, scenarios });
  },
  loadScenarioModal: data => async dispatch => {
    dispatch({ type: SCENARIO_MODAL_LOAD_TYPE, data });
  }
};

export const reducer = (state, action) => {
  state = state || initialState;

  if (action.type === requestScenariosType) {
    return {
      ...state,
      loading: true
    };
  }

  if (action.type === receiveScenariosType) {
    const { scenarios } = action;
    return {
      ...state,
      scenarios,
      loading: false
    };
  }

  if (action.type === SCENARIO_MODAL_LOAD_TYPE) {
    const { data } = action;
    return {
      ...state,
      data
    };
  }

  return state;
};
